import { Component, inject, input } from '@angular/core';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { CrowdFundingModel, ICrowdDocument } from '../../../models/crowd-funding.model';
import { DownloadService } from 'libs/applets/wealth/src/lib/shared/services/download-file.service';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';

@Component({
  selector: 'app-crowd-document-segment',
  templateUrl: './crowd-document-segment.component.html',
  styleUrls: ['./crowd-document-segment.component.scss'],
  standalone: true,
  imports: [NgxButtonComponent, NgxDividerComponent],
})
export class CrowdDocumentSegmentComponent {
  crowd = input<CrowdFundingModel>();
  private downloadService = inject(DownloadService);
  protected readonly BorderColorsEnum = BorderColorsEnum;

  download(doc: ICrowdDocument) {
    doc['downloading'] = true;
    this.downloadService.downloadFile(doc.filePath, doc.title, doc);
  }
}
